/**
 * Created by danielg on 8/16/15.
 */
define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');

    var SessionStorageController = function () {
        _init.call(this);
    };
    SessionStorageController.prototype.applicationType = 'lpSessionStorageController';

    /**
     * Gets an object from the session storage based on the provided data
     * @param data.name - The name for the session storage
     * @param data.key - The key for the session storage
     * @returns {*} - The stored object
     */
    SessionStorageController.prototype.getSessionData = function(data) {
        if (lpTag.WebAgent.WebAgentSessionStorage && data) {
            return lpTag.WebAgent.WebAgentSessionStorage.getSessionData(data.name, data.key);
        }
    };

    /**
     * Saves an object to the session storage based on the provided data
     * @param data.name - The name for the session storage
     * @param data.key - The key for the session storage
     * @param data.value - The object to store
     */
    SessionStorageController.prototype.saveSessionData = function(data) {
        if (lpTag.WebAgent.WebAgentSessionStorage && data) {
            lpTag.WebAgent.WebAgentSessionStorage.setSessionData(data.name, data.key, data.value);
        }
    };

    /**
     * Removes the session storage based on the provided data
     * @param data.name - The name for the session storage
     * @param data.key - The key for the session storage
     */
    SessionStorageController.prototype.removeSessionData = function(data) {
        if (lpTag.WebAgent.WebAgentSessionStorage && data) {
            lpTag.WebAgent.WebAgentSessionStorage.removeSessionData(data.name, data.key);
        }
    };

    /////////// PRIVATE FUNCTIONS /////////////

    function _init() {
        _createLogger.call(this);
    }

    /**
     * Creates the logger for the controller
     * @private
     */
    function _createLogger() {
        if (WebAgentLogger.getLogger) {
            this.logger = WebAgentLogger.getLogger(this.applicationType);
        }
    }

    return SessionStorageController;

});
